const useV2 = window.isOnboardingV2 === 'true';
const styles = useV2 ? require('./styles-v2') : require('./styles-v1');

module.exports = styles;
